import {CarCollisionDetailsResponse, CarCollisionDto} from '../../Models/CollisionModel'
import * as CollisionConnector from '../../Connectors/CollisionConnector'
import * as CollisionActionModel from "../Actions/Models/CollisionActionModel"
import {CollisionReducer} from "../Reducers/CollisionReducer"
import * as ActionTypes from './EnumTypes/ActionEnumTypes';


export function pullCollisionDataframesWithToken(token:string) {
    return async dispatch => {
        try {
            const historyCrash = await CollisionConnector.getCollisionWithToken(token);
            await dispatch(setCollisionDataframes(historyCrash.data));

            if (historyCrash.data.speedFrames && historyCrash.data.speedFrames.length) {
                dispatch(setActiveCollisionDataframes(historyCrash.data.speedFrames[0].dateTime));
            }
        } catch (err) {
            //gg
        }
    }
}

export function getCollisionDataframes(crashId: number) {
    return async dispatch => {
        try {
            const historyCrash = await CollisionConnector.getCollision(crashId);
            await dispatch(setCollisionDataframes(historyCrash.data));

            if (historyCrash.data.speedFrames && historyCrash.data.speedFrames.length) {
                dispatch(setActiveCollisionDataframes(historyCrash.data.speedFrames[0].dateTime));
            }
        } catch (err) {
            //gg
        }
    };
}

export function setCollisionDataframes(getHistoryCrashResponse: CarCollisionDetailsResponse): CollisionActionModel.GetCrashDataframesSuccessAction {
    return {
        reducer: CollisionReducer,
        method: 'setCollisionDataframes',
        type: ActionTypes.Collision.SET_COLLISION_DATAFRAMES,
        payload: {
            dataframesAcceleration: getHistoryCrashResponse.accelerationFrames,
            dataframesSpeed:getHistoryCrashResponse.speedFrames,
            crashDataframe:getHistoryCrashResponse.collisionDataframe,
            carCollision:getHistoryCrashResponse.carCollision
        }
    };
}

export function setActiveCollisionDataframes(dateTime: string): CollisionActionModel.SetActiveDataframesAction {
    return {
        reducer: CollisionReducer,
        type: ActionTypes.Collision.SET_ACTIVE_DATA_FRAMES,
        method: 'setActiveDataframes',
        payload: {
            activeDataframes: dateTime
        }
    };
}


export function pullCollisionsList(filter?:URLSearchParams) {
    return async dispatch => {
        try {
            const colisionList = await CollisionConnector.getCollisionList(filter);
            dispatch(setCollisionsList(colisionList.data.carCollisions.results));
        } catch (err) {
            //gg
        }
    };
}

export function setCollisionsList(collisionList:Array<CarCollisionDto>):CollisionActionModel.SetCollisionsListAction {
    return {
        reducer: CollisionReducer,
        type: ActionTypes.Collision.SET_COLLISIONS_LIST,
        method: 'setCollisionsList',
        payload: {
            collisionList
        }
    };
}

export function setActiveCollision(collisionId:number):CollisionActionModel.SetActiveCollisionAction {
    return {
        reducer: CollisionReducer,
        type: ActionTypes.Collision.SET_ACTIVE_COLLISION,
        method: 'setActiveCollision',
        payload: {
            collisionId
        }
    };
}


export function pullExternalUrl(collisionId: number) {
    return async dispatch => {
        try {
            const collisionTokenResp = await CollisionConnector.getCollisionToken(collisionId);
            await dispatch(setCollisionToken(collisionTokenResp.data.token));
        } catch (err) {
            //gg
        }
    };
}

export function setCollisionToken(collisionToken:string):CollisionActionModel.SetCollisionToken {
    return {
        reducer: CollisionReducer,
        type: ActionTypes.Collision.SET_COLLISION_TOKEN,
        method: 'setCollisionToken',
        payload: {
            collisionToken
        }
    };
}


// export function setActiveDataframe(activeDataframe: VehiclesModule.Types.CarDataframeDto): CollisionActionModel.SetActiveDataframe {
//     return {
//         type: ActionTypes.History.SET_ACTIVE_DATAFRAME,
//         payload: {
//             activeDataframe
//         }
//     };
// }


// WEBPACK FOOTER //
// ./src/Redux/Actions/CollisionActions.ts